frappe.ui.form.MultiStepOptionsDialog = class MultiStepOptionsDialog {
	constructor(opts) {
		Object.assign(this, opts);
		this.currentStep = 0;
		this.stepData = {};
		this.init();
	}

	init() {
		this.buildContent();
		this.createDialog();
	}

	buildContent() {
		this.content = this.createContainer();
		this.renderCurrentStep();
	}

	getCurrentStepConfig() {
		return this.steps[this.currentStep];
	}

	getNextStepIndex() {
		let next = this.currentStep + 1;
		while (next < this.steps.length) {
			const nextStep = this.steps[next];
			if (!nextStep.condition || nextStep.condition(this.stepData)) {
				return next;
			}
			next++;
		}
		return -1;
	}

	getPreviousStepIndex() {
		let prev = this.currentStep - 1;
		while (prev >= 0) {
			const prevStep = this.steps[prev];
			if (!prevStep.condition || prevStep.condition(this.stepData)) {
				return prev;
			}
			prev--;
		}
		return -1;
	}

	getDisplayStepNumber() {
		return this.steps.slice(0, this.currentStep + 1).filter((step) => {
			return !step.condition || step.condition(this.stepData);
		}).length;
	}

	getVisibleStepsCount() {
		return this.steps.filter((step) => {
			return !step.condition || step.condition(this.stepData);
		}).length;
	}

	renderCurrentStep() {
		const stepConfig = this.getCurrentStepConfig();
		const container = this.content.querySelector(".multioptions-select-container");
		container.innerHTML = "";

		// Step title and progress
		const header = document.createElement("div");
		header.className = "mb-4 w-100";

		header.innerHTML = `
			<div class="small text-muted">${__("Step")} ${this.getDisplayStepNumber()} ${__(
			"of"
		)} ${this.getVisibleStepsCount()}</div>
			<h3 class="fw-semibold mb-3">${stepConfig.title || ""}</h3>
		`;
		container.appendChild(header);

		if (stepConfig.type === "options") {
			const optionsDiv = this.createOptionsStep(stepConfig);
			container.appendChild(optionsDiv);
		} else if (stepConfig.type === "form") {
			const formDiv = this.createFormStep(stepConfig);
			container.appendChild(formDiv);
		}

		const navDiv = this.createNavigation(stepConfig.type);
		container.appendChild(navDiv);
	}

	createOptionsStep(stepConfig) {
		const optionsDiv = document.createElement("div");
		optionsDiv.className = "w-100 d-flex flex-column gap-3 mb-4";

		stepConfig.options.forEach((option) => {
			const optionBtn = document.createElement("button");
			optionBtn.className =
				"d-flex align-items-start gap-3 rounded border p-3 text-start bg-white option-tile w-100";
			optionBtn.innerHTML = `
				<div class="text-primary fs-4 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px; background-color: #f1f5ff; border-radius: .375rem;">
					${frappe.utils.icon(option.icon || "file", "md")}
				</div>
				<div class="flex-grow-1">
					<div class="fw-semibold">${option.label}</div>
					<div class="text-muted small">${option.description || ""}</div>
				</div>
			`;
			optionBtn.addEventListener("click", () => {
				this.stepData[stepConfig.fieldname] = option.value || option.label;
				if (option.action) option.action();
				this.getNextStepIndex() !== -1 ? this.nextStep() : this.finish();
			});
			optionsDiv.appendChild(optionBtn);
		});

		return optionsDiv;
	}

	createFormStep(stepConfig) {
		const formDiv = document.createElement("div");
		formDiv.className = "multioptions-form-step w-100";
		this.step_controls = {};

		stepConfig.fields.forEach((field) => {
			const fieldContainer = document.createElement("div");
			fieldContainer.className = "form-group mb-3";

			let control = frappe.ui.form.make_control({
				df: field,
				parent: fieldContainer,
				render_input: true,
			});

			if (control.wrapper) {
				formDiv.appendChild(fieldContainer);
				this.step_controls[field.fieldname] = control;

				let value =
					this.stepData[field.fieldname] !== undefined
						? this.stepData[field.fieldname]
						: field.default;
				if (value !== undefined) {
					control.set_value(value);
				}
			}
		});

		return formDiv;
	}

	createNavigation(step_type) {
		const navDiv = document.createElement("div");
		navDiv.className = "d-flex justify-content-end w-100 pt-2";

		if (this.currentStep > 0) {
			const prevBtn = document.createElement("button");
			prevBtn.className = "btn btn-default mr-2";
			prevBtn.textContent = __("Previous");
			prevBtn.addEventListener("click", () => this.previousStep());
			navDiv.appendChild(prevBtn);
		}

		if (step_type != "options") {
			const nextBtn = document.createElement("button");
			nextBtn.className = "btn btn-primary";
			const nextStepIndex = this.getNextStepIndex();
			nextBtn.textContent = nextStepIndex === -1 ? __("Save") : __("Next");
			nextBtn.addEventListener("click", () => {
				nextStepIndex === -1 ? this.finish() : this.nextStep();
			});
			navDiv.appendChild(nextBtn);
		}

		return navDiv;
	}

	createContainer() {
		const container = document.createElement("div");
		container.className = "multioptions-select w-100 p-4";
		const inner = document.createElement("div");
		inner.className =
			"multioptions-select-container d-flex flex-column align-items-start w-100";
		container.appendChild(inner);
		return container;
	}

	nextStep() {
		const currentStepConfig = this.getCurrentStepConfig();
		if (currentStepConfig.type === "form") this.collectFormData();

		const nextStepIndex = this.getNextStepIndex();
		if (this.validateCurrentStep() && nextStepIndex !== -1) {
			this.currentStep = nextStepIndex;
			this.renderCurrentStep();
			this.onStepChange?.();
		}
	}

	previousStep() {
		const prevStepIndex = this.getPreviousStepIndex();
		if (prevStepIndex !== -1) {
			this.currentStep = prevStepIndex;
			this.renderCurrentStep();
			this.onStepChange?.();
		}
	}

	collectFormData() {
		if (this.step_controls) {
			Object.keys(this.step_controls).forEach((fieldname) => {
				this.stepData[fieldname] = this.step_controls[fieldname].get_value();
			});
		}

		const inputs = this.content.querySelectorAll("[data-fieldname]");
		inputs.forEach((input) => {
			if (this.stepData[input.dataset.fieldname] === undefined) {
				this.stepData[input.dataset.fieldname] = input.value;
			}
		});
	}

	validateCurrentStep() {
		const step = this.getCurrentStepConfig();
		if (step.type === "form") {
			this.collectFormData();
			const missing = step.fields.filter((f) => f.reqd && !this.stepData[f.fieldname]);
			if (missing.length > 0) {
				frappe.msgprint(__("Field {0} is required", [missing[0].label]));
				return false;
			}
		}
		return true;
	}

	finish() {
		if (this.validateCurrentStep()) {
			this.dialog.hide();
			this.onComplete?.(this.stepData);
		}
	}

	createDialog() {
		this.dialog = new frappe.ui.Dialog({
			fields: [{ fieldtype: "HTML", fieldname: "content" }],
			size: this.size || "large",
			onhide: () => {
				this.dialog.is_visible = false;
			},
		});
		this.dialog.header.hide();
		this.dialog.get_field("content").wrapper.appendChild(this.content);
		this.dialog.show();
	}
};
